import React from "react";
import "./DomainNotAllowed.css";

function DomainNotAllowed({ hostname = "" }) {
  return (
    <div className="domain-not-allowed" role="alert">
      <div className="domain-not-allowed-card">
        <h1>Access not allowed</h1>
        <p>
          This frontend URL is not authorized.
          {hostname ? (
            <>
              {" "}
              <strong>{hostname}</strong> cannot open this POS.
            </>
          ) : null}
        </p>
        <p className="domain-not-allowed-hint">
          Open the app from an approved domain only.
        </p>
      </div>
    </div>
  );
}

export default DomainNotAllowed;
